/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './tumor-board-occurrence.reducer';

export const TumorBoardOccurrence = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const tumorBoardOccurrenceList = useAppSelector(state => state.tumorBoardOccurrence.entities);
  const loading = useAppSelector(state => state.tumorBoardOccurrence.loading);
  const totalItems = useAppSelector(state => state.tumorBoardOccurrence.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="tumor-board-occurrence-heading" data-cy="TumorBoardOccurrenceHeading">
        <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.home.title">Tumor Board Occurrences</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/tumor-board-occurrence/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.home.createLabel">Create new Tumor Board Occurrence</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.tumorBoardOccurrence.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {tumorBoardOccurrenceList && tumorBoardOccurrenceList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('eventName')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.eventName">Event Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eventName')} />
                </th>
                <th className="hand" onClick={sort('eventDescription')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.eventDescription">Event Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eventDescription')} />
                </th>
                <th className="hand" onClick={sort('scheduleStartTime')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.scheduleStartTime">Schedule Start Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('scheduleStartTime')} />
                </th>
                <th className="hand" onClick={sort('scheduleEndTime')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.scheduleEndTime">Schedule End Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('scheduleEndTime')} />
                </th>
                <th className="hand" onClick={sort('scheduleDate')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.scheduleDate">Schedule Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('scheduleDate')} />
                </th>
                <th className="hand" onClick={sort('outcomeSummary')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.outcomeSummary">Outcome Summary</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('outcomeSummary')} />
                </th>
                <th className="hand" onClick={sort('startedAt')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.startedAt">Started At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startedAt')} />
                </th>
                <th className="hand" onClick={sort('completedAt')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.completedAt">Completed At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('completedAt')} />
                </th>
                <th className="hand" onClick={sort('createdById')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.createdById">Created By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdById')} />
                </th>
                <th className="hand" onClick={sort('createdByType')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.createdByType">Created By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdByType')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.board">Board</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {tumorBoardOccurrenceList.map((tumorBoardOccurrence, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/tumor-board-occurrence/${tumorBoardOccurrence.id}`} color="link" size="sm">
                      {tumorBoardOccurrence.id}
                    </Button>
                  </td>
                  <td>{tumorBoardOccurrence.eventName}</td>
                  <td>{tumorBoardOccurrence.eventDescription}</td>
                  <td>{tumorBoardOccurrence.scheduleStartTime}</td>
                  <td>{tumorBoardOccurrence.scheduleEndTime}</td>
                  <td>{tumorBoardOccurrence.scheduleDate}</td>
                  <td>{tumorBoardOccurrence.outcomeSummary}</td>
                  <td>{tumorBoardOccurrence.startedAt}</td>
                  <td>{tumorBoardOccurrence.completedAt}</td>
                  <td>{tumorBoardOccurrence.createdById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${tumorBoardOccurrence.createdByType}`} />
                  </td>
                  <td>{tumorBoardOccurrence.active ? 'true' : 'false'}</td>
                  <td>{tumorBoardOccurrence.cursor}</td>
                  <td>{tumorBoardOccurrence.lastUpdated}</td>
                  <td>{tumorBoardOccurrence.microSec}</td>
                  <td>{tumorBoardOccurrence.timestampEntry}</td>
                  <td>
                    {tumorBoardOccurrence.board ? (
                      <Link to={`/tumor-board/${tumorBoardOccurrence.board.id}`}>{tumorBoardOccurrence.board.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/tumor-board-occurrence/${tumorBoardOccurrence.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/tumor-board-occurrence/${tumorBoardOccurrence.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/tumor-board-occurrence/${tumorBoardOccurrence.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.home.notFound">No Tumor Board Occurrences found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={tumorBoardOccurrenceList && tumorBoardOccurrenceList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TumorBoardOccurrence;
